export default __webpack_public_path__ + "static/media/notesSchool.93fdc85c.svg";